export const EZ_DATA_RECEIVED = 'EZ_DATA_RECEIVED';
export const eZDataReceived = data => ({
    type: EZ_DATA_RECEIVED,
    payload: data
});
